"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClientSerializer = void 0;
var createClientSerializer_1 = require("./createClientSerializer");
Object.defineProperty(exports, "createClientSerializer", { enumerable: true, get: function () { return createClientSerializer_1.createClientSerializer; } });
